<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-07-03 15:20:58
-->
<template>
  <div class="add-danwei">
    <el-form ref="ruleForm"
             :model="viewData"
             :rules="rules"
             label-width="100px">
      <el-form-item label="名称"
                    prop="name">
        <el-input size="mini"
                  v-model="viewData.name" />
      </el-form-item>
      <el-form-item label="手机"
                    prop="sort">
        <el-switch size="mini"
                   v-model="viewData.is_mobile"
                   class="drawer-switch"
                   active-color="#13ce66"
                   inactive-color="#ff4949"
                   :active-value="true"
                   :inactive-value="false" />
      </el-form-item>
      <el-form-item label="广告位描述"
                    prop="content">
        <el-input type="textarea"
                  rows="5"
                  v-model="viewData.content" />
      </el-form-item>
    </el-form>
    <div class="fix-fotter">
      <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;"
                 size="mini"
                 type="primary"
                 @click="tijiao('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
import ad from "@/api/console/ad";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      viewData: {
        adpos_id: "",
        name: "",
        is_mobile: 0,
        content: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Pagination,
  },
  created () { },
  methods: {
    /**
     * @name: 初始化列表
     * @param {*} obj
     * @return {*}
     * @desc:
     */
    initFun (obj) {
      let that = this
      this.viewData = {
        adpos_id: "",
        name: "",
        is_mobile: 0,
        content: ""
      }
      if (obj.id) {
        // 编辑
        this.viewData.adpos_id = obj.id;
        ad.detail({ adpos_id: obj.id }).then((res) => {
          console.log(res)
          if (res.code == 200) {
            that.viewData = res.result
            that.viewData.adpos_id = res.result.id;
          }
        });
      } else {
        // 新增
      }
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc: 
     */
    tijiao (formName) {
      let that = this
      console.log(this.viewData)
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.viewData.adpos_id) {
            // 编辑
            ad.edit(this.viewData).then(res => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.$emit('onUpdateDrawer', -1)
              }
            })
          } else {
            // 新增
            ad.create(this.viewData).then(res => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.$emit('onUpdateDrawer', -1)
              }
            })
          }

        } else {
          this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 清空form
     * @return {*}
     * @desc:
     */
    resetForm () {
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
